import dayjs from "dayjs";

export const getTimeZoneSpecificDate = (timeZone: string, dateString: string) => {
    const timeZoneCurentTime = timeZone && dayjs()?.tz(`${timeZone}`)?.format('hh:mm:ss');
    // Make specific format for long date acceptable to all browsers
    return timeZoneCurentTime ? new Date(dayjs(`${dateString} ${timeZoneCurentTime}`)?.format('ddd MMM DD YYYY hh:mm:ss')) : new Date(`${dateString}`)
}